// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import Modal from './modal';
import MessageBoxButton from './message-box-button';

export default class MessageBox extends React.Component {
  static propTypes = {
    buttons: PropTypes.array,
    input: PropTypes.bool,
    placeholder: PropTypes.string,
    default: PropTypes.string,
    onDismiss: PropTypes.func,
    show: PropTypes.bool,
    title: PropTypes.string,
    message: PropTypes.string,
    width: PropTypes.number,
  };

  static defaultProps = {
    show: true,
    width: 500,
  };

  constructor(props) {
    super(props);

    this.state = {
      inputValue: props.default || '',
    };
  }

  componentDidMount() {
    this.updatePosition();
  }

  componentDidUpdate(prevProps, prevState) {
    this.updatePosition();
  }

  render() {
    const { styles } = MessageBox;

    const style = {
      width: this.props.width,
      marginLeft: -(this.props.width / 2),
    };

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleHide}
        dialogTransitionTimeout={150}
        backdropTransitionTimeout={150}
      >
        <div
          data-testid="message-box"
          className={cx('modal-content', styles.messageBox)}
          ref={this.bindNode}
          style={style}
        >
          {this.renderTitle()}
          {this.renderMessage()}
          {this.renderInput()}
          {this.renderButtons()}
        </div>
      </Modal>
    );
  }

  renderTitle() {
    if (this.props.title) {
      const { styles } = MessageBox;

      return (
        <div className={styles.title}>{this.props.title}</div>
      );
    }

    return null;
  }

  renderMessage() {
    if (!this.props.message) {
      return null;
    }

    const { styles } = MessageBox;

    return (
      <div className={styles.messageContainer}>
        {this.props.message}
      </div>
    );
  }

  renderInput() {
    if (!this.props.input) {
      return null;
    }

    const { styles } = MessageBox;

    return (
      <div className={styles.inputContainer}>
        <input
          type="text"
          className={styles.input}
          value={this.state.inputValue}
          placeholder={this.props.placeholder}
          onChange={this.handleInputChange}
        />
      </div>
    );
  }

  renderButtons() {
    if (!this.props.buttons) {
      return null;
    }

    const { styles } = MessageBox;

    return (
      <div className={styles.buttons}>
        {this.props.buttons.map((button, index) => (
          <MessageBoxButton
            key={`button-${index}`}
            buttonText={button}
            index={index}
            onClick={this.handleClick}
          />
        ))}
      </div>
    );
  }

  handleInputChange = (event) => {
    this.setState({ inputValue: event.target.value });
  };

  handleClick = (button, index) => {
    this.props.onDismiss(index, this.state.inputValue);
    this.setState({ inputValue: '' });
  };

  bindNode = (node) => {
    this.messageBox = node;
  };

  handleHide = (event) => {
    // nothing
  };

  updatePosition() {
    if (this.messageBox) {
      this.messageBox.style.marginTop = `${-this.messageBox.offsetHeight / 2}px`;
    }
  }
}

const styles = cssInJS({
  messageBox: {
    position: 'fixed',
    backgroundColor: '#fff',
    left: '50%',
    top: '50%',
    borderRadius: 3,
    fontFamily: THEME.fontFamily,
    padding: 30,
    boxShadow: '0 14px 45px rgba(0,0,0,0.25), 0 10px 18px rgba(0,0,0,0.22)',
  },

  title: {
    marginBottom: 10,
    fontWeight: 'bold',
  },

  messageContainer: {
    marginBottom: 10,
  },

  buttons: {
    textAlign: 'right',
    marginTop: 10,
  },

  inputContainer: {
    padding: 0,
  },

  input: {
    width: '100%',
    outline: 'none',
  },

  body: {
    maxHeight: 400,
    width: 440,
    overflow: 'auto',
    color: '#777',
    whiteSpace: 'pre-wrap',
  },
});

MessageBox.styles = styles;
